import React, { useState } from "react";
import { FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "./LoginStepOne.css";
import { recordLoginHistory } from "../../utils/loginHistory";
import API from "../../services/api";
import { useAuth } from "../../context/AuthContext";
import { memoryStorage } from "../../utils/memoryStorage";

const LoginStepOne = ({ onSuccess, onSwitchToSignup, onForgotPassword }) => {
  const [value, setValue] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();
  const { setUser } = useAuth();

  const detectType = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input) ? "email" : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!value.trim()) {
      setError("Please enter your email");
      return;
    }

    if (!detectType(value)) {
      setError("Please enter a valid email");
      return;
    }

    if (!password.trim()) {
      setError("Please enter your password");
      return;
    }


    try {
      const res = await API.post(
        "/auth/login",
        {
          email: value,
          password,
        },
        {
          withCredentials: true,
        }
      ); 


      setUser(res.data.user);
      memoryStorage.setItem("user", JSON.stringify(res.data.user));
      recordLoginHistory(res.data.user);

      const role = (res.data.user?.role || "").toUpperCase();

      if (role === "SUPER_ADMIN") {
        navigate("/components/Admins/AdminLayout");
      } else if (role === "HR_ADMIN") {
        navigate("/HRadmin/HRAdminLayout");
      } else if (role === "CONTENT_MANAGER") {
        navigate("/ContentManager/ContentManagerLayout/dashboard");
      } else {
        navigate("/candidate/candidatecareer");
      }

      

      if (onSuccess) onSuccess();
    } catch (err) {
      console.log("LOGIN ERROR:", err);
      setError(err.response?.data?.message || "Login failed");
    }
  };

  const handleSignupClick = () => {
    if (onSwitchToSignup) onSwitchToSignup();
  };

  const handleForgotClick = () => {
    if (onForgotPassword) onForgotPassword();
  };

  return (
    <div className="login-component-container">
      <div className="auth-wrapper">
        <div className="background-shape" />

        <div className="welcome-section signin">
          <div className="welcome-card">
            <div className="brand-mark">BlackRoth <sup>TM</sup></div>
            <div className="welcome-copy">
              <h2 className="slide-element">You’re one step away</h2>
              <p>Login to continue your experience</p>
              <p>Access everything you’ve been working on</p>
            </div>
          </div>
        </div>

        <div className="credentials-panel signin">
          <h2 className="slide-element">Welcome back</h2>
          <p className="form-subtitle slide-element">
            Sign in to continue managing your account and workspace.
          </p>

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="field-wrapper slide-element">
              <input
                type="text"
                name="login_identifier"
                autoComplete="off"
                placeholder=" "
                value={value}
                onChange={(e) => {
                  setValue(e.target.value);
                  setError("");
                }}
                required
              />
              <label>Email Address</label>
              <FaUser className="input-icon" />
            </div>

            <div className="field-wrapper slide-element">
              <input
                type={showPassword ? "text" : "password"}
                name="login_password"
                autoComplete="new-password"
                placeholder=" "
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                required
              />
              <label>Password</label>
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>

            {error && <p className="error-message">{error}</p>}

            <div className="field-wrapper slide-element">
              <button className="submit-button" type="submit">
                Login
              </button>
            </div>

            <div className="forgot-link slide-element">
              <button
                type="button"
                className="link-button"
                onClick={handleForgotClick}
              >
                Forgot Password?
              </button>
            </div>

            <div className="switch-link slide-element">
              <p>
                Don&apos;t have an account?
                <button
                  type="button"
                  className="register-trigger"
                  onClick={handleSignupClick}
                >
                  Sign Up
                </button>
              </p>
            </div>

            <p className="legal-note">
              By signing in, you agree to our{" "}
              <Link to="/terms" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link to="/privacy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </Link>
              {"."}
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginStepOne;
 
